import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkButton, UitkButtonSize } from './uitk-button.esm.js';
import { UitkPrimaryButton } from './uitk-primary-button.esm.js';

var UitkFloatingFullWidthButton = /** @class */ (function (_super) {
    __extends(UitkFloatingFullWidthButton, _super);
    function UitkFloatingFullWidthButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkFloatingFullWidthButton.prototype.render = function () {
        var props = this.props;
        var cssClassNames = classNames("".concat(UitkButton.baseClassName, "-floating-full-width"), props.className);
        return (React.createElement(UitkPrimaryButton, __assign({ size: UitkButtonSize.LARGE, isFullWidth: true }, props, { className: cssClassNames })));
    };
    UitkFloatingFullWidthButton.displayName = 'UitkFloatingFullWidthButton';
    return UitkFloatingFullWidthButton;
}(React.Component));

export { UitkFloatingFullWidthButton };
